import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, translate, getUserNameToName, updateTextFields, isNullOrEmpty, downloadFile, formatDateToPtbr } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Collapsible, Table, Modal } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import AviexpUpdate from './AviexpUpdate';

const AviexpContainer = (props) => {
    const [aviexps, setAviexps] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [filter, setFilter] = useState({ internal: false });
    const [openModal, setOpenModal] = useState(false);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [dataModal, setDataModal] = useStateWithPromise();

    useEffect(() => {
        props.getUnloadLocations()
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setAviexps(props.aviexps?.items || []);
        // eslint-disable-next-line
    }, [props?.aviexps?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getAviexpPaged({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItemChange = (item, edit) => {
        setDataModal({ ...item }).then(() => {
            if (edit) {
                setOpenModalEdit(true);
            } else {
                setOpenModal(true);
            }
            updateTextFields()
        })
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'container',
                header: 'Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'sellerCoforCode',
                header: 'Cofor',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'updatedOn',
                body: (rowData) => formatDateToPtbr(rowData.updatedOn),
                header: 'Data Atualização',
                align: 'left',
                sortable: true
            },
            {
                field: 'updatedBy',
                header: 'Atualizado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const sendAssocieteContainerAviexp = (container) => {
        props.associeteContainerAviexp({
            id: dataModal.id,
            container: container
        }, () => {
            setOpenModal(false);
            setDataModal({})
            onSearch(true);
        })
    }

    const exportCvsClick = (aviexp) => {
        props.exportCsv(aviexp.id, (data) => {
            downloadFile(data, 'Entrada+ASN.csv', "data:text/csv", false);
        })
    }

    const configActions = () => [
        {
            function: (row) =>
                <i className="material-icons sixth-text-color"
                    onClick={() => onSelectItemChange(row, true)}
                    title='Editar'
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>
                    edit
                </i>
        },
        {
            function: (row) => (

                !row?.containerAssociation && <i className="material-icons sixth-text-color"
                    onClick={() => {
                        onSelectItemChange(row)
                    }}
                    title='Associar Container'
                    style={{ fontSize: '1.85rem', cursor: 'pointer' }}>crop_rotate</i>
            )
        },
        {
            function: (row) =>
                <i className="material-icons sixth-text-color"
                    onClick={() => exportCvsClick(row)}
                    title='Exportar Click'
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>
                    file_download
                </i>
        }
    ];


    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Aviexp" }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="container"
                                                name='container'
                                                label="Container"
                                                type="text"
                                                value={filter?.container || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="cofor"
                                                name='cofor'
                                                label="Cofor"
                                                type="text"
                                                value={filter?.cofor || ''}
                                                onChange={onChange}
                                            />
                                        </div>

                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="remorque"
                                                name='remorque'
                                                label="Remorque"
                                                type="text"
                                                value={filter?.dischargePortCode || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="partNumber"
                                                name='partNumber'
                                                label="Nº BL"
                                                type="text"
                                                value={filter?.partNumber || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                value={filter.inicialDate}
                                                type="date"
                                                label="Data Inicio"
                                                id="inicialDate"
                                                name="inicialDate"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                value={filter.finalDate}
                                                type="date"
                                                label="Data fim"
                                                id="finalDate"
                                                name="finalDate"
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />

                </div>
                <Table
                    totalPages={props.aviexps?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={aviexps}
                    actions={configActions()} />
            </div>
            <Modal
                maxHeight='auto'
                open={openModal}
                dismissible={false}
                id="modalContainerAviexp"
                btnCancel={translate('cancel', 'general')}
                onConfirm={() => {
                    var containerInpput = document.getElementById('containerInput')?.value
                    if (!isNullOrEmpty(containerInpput)) {
                        sendAssocieteContainerAviexp(containerInpput)
                    }
                }}
                onCancel={() => {
                    setOpenModal(false);
                    setDataModal({})
                }}
                closeModal={() => {
                    setOpenModal(false);
                    setDataModal({})
                }}
                children={
                    <div className="container-fluid" style={{ marginTop: '25px', }}>
                        <div className="container">
                            <form id="setContainerAviexp" className="col s12">
                                <span className="title col s12">{"Alterar número Container Aviexp"}</span>

                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field no-padding col s11">
                                        <Input
                                            id="containerInput"
                                            name='containerInput'
                                            label="Container"
                                            type="text"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                }
            />
            <Modal
                maxHeight='auto'
                open={openModalEdit}
                dismissible={false}
                id="modalContainerAviexpEdit"
                closeModal={() => {
                    setOpenModalEdit(false);
                    setDataModal({})
                }}
                children={
                    <AviexpUpdate
                        closeModal={() => {
                            setOpenModalEdit(false);
                            setDataModal({})
                        }} data={dataModal} />
                }
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        aviexps: state.containerReducer.aviexpPaged,
        containerSizes: state.containerReducer.containerSizes,
        containerTypes: state.containerReducer.containerTypes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAviexpPaged: (filter) => {
            dispatch(ContainerService.getAviexpPaged(filter));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportClickCsv(filter, callback));
        },
        associeteContainerAviexp: (data, callback) => {
            dispatch(ContainerService.associeteContainerAviexp(data, callback));
        },
        getUnloadLocations: () => {
            dispatch(ContainerService.getUnloadLocation(null));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AviexpContainer));
